(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["CheckoutWrapper"] = factory();
	else
		root["CheckoutWrapper"] = factory();
})(window, function() {
return 